import { useAuthContext } from '../context/AuthContext';

// Re-export useAuthContext as useAuth to maintain backward compatibility
export const useAuth = useAuthContext;
